import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import type { DeviceKind } from '../../../camera/types';
import type { CameraSide } from '../../../camera/utils/get-camera-options';
type PreviewProps = {
  imageSrc: string;
  onRetake: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  cameraKind: CameraSide;
  deviceKind: DeviceKind;
  title?: string;
};
const Preview = t0 => {
  const $ = _c(31);
  const {
    imageSrc,
    onRetake,
    onConfirm,
    isLoading,
    cameraKind,
    deviceKind,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.photo-capture.preview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== title) {
    t2 = title && <p className="text-label-1 text-primary text-center mb-4">{title}</p>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = title ? "max-h-[180px] w-auto mx-auto" : "w-full";
  const t4 = cameraKind === "front" && "-scale-x-100";
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = cx("rounded", t3, t4);
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== cameraKind || $[7] !== deviceKind || $[8] !== imageSrc || $[9] !== t5) {
    t6 = <div className="flex items-start justify-center w-full"><img data-dd-privacy="mask" src={imageSrc} data-camera-kind={cameraKind} data-device-kind={deviceKind} className={t5} alt="Preview" /></div>;
    $[6] = cameraKind;
    $[7] = deviceKind;
    $[8] = imageSrc;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isLoading || $[14] !== onConfirm || $[15] !== t7) {
    t8 = <Button fullWidth={true} onClick={onConfirm} variant="primary" loading={isLoading} disabled={isLoading} size="large">{t7}</Button>;
    $[13] = isLoading;
    $[14] = onConfirm;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp2);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== isLoading || $[20] !== onRetake || $[21] !== t9) {
    t10 = <Button fullWidth={true} onClick={onRetake} variant="secondary" disabled={isLoading} size="large">{t9}</Button>;
    $[19] = isLoading;
    $[20] = onRetake;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== deviceKind || $[24] !== t10 || $[25] !== t8) {
    t11 = <div className="flex justify-center items-center flex-col w-full gap-y-2 mt-4" data-device-kind={deviceKind}>{t8}{t10}</div>;
    $[23] = deviceKind;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t2 || $[29] !== t6) {
    t12 = <div className="flex items-center flex-col justify-center w-full">{t2}{t6}{t11}</div>;
    $[27] = t11;
    $[28] = t2;
    $[29] = t6;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
export default Preview;
function _temp($) {
  return $.confirm;
}
function _temp2($_0) {
  return $_0.retake;
}